import { gql } from "@apollo/client";

export const CORE_PERMIT_TYPE_FIELDS = gql`
  fragment CorePermitTypeFields on PermitType {
    id
    name
    blueprintKey
  }
`;
